  /*============Vehicle Tagging Controller
  ================================*/
  angular
  .module('vppApp')
  .controller('vehicleTaggingEvController', vehicleTaggingEvController);

  vehicleTaggingEvController.$inject = ['$rootScope', '$scope', '$state', 'apiFactory', 'VarientService', 'AuthenticationService', 'CustomerService', 'VehicleDetailService', 'ProgramInfoService'];

function vehicleTaggingEvController($rootScope, $scope, $state, apiFactory, VarientService, AuthenticationService, CustomerService, VehicleDetailService, ProgramInfoService) {
  $scope.varient = VarientService.getVarientName();

    var convertToOptions = function (values) {
      var options = [];
      Object.keys(values).map(function(key) {
        options.push({
          label: values[key],
          value: key
        });
      });
      return options;
    };

    $scope.sortKey = 'mileage';
    $scope.reverse = false;

    $scope.sortData = function (column) {
      $scope.reverse = ($scope.sortKey === column) ? !$scope.reverse : false;
      $scope.sortKey = column;

      // Custom comparator function
      $scope.customComparator = function (value1, value2) {
        // Check if the current sort column is 'mileage'
        if ($scope.sortKey === 'mileage') {
          return value1.value - value2.value; // Sort numerically
        } else {
          // Default behavior: sort as strings
          return (value1.value > value2.value) ? 1 : (value1.value < value2.value) ? -1 : 0;
        }
      };
    };


    $scope.sortOptions = [
      {key: 'mileage', label:'Mileage ↑', reverse:false},
      {key: 'mileage', label:'Mileage ↓', reverse:true},
      {key: 'totalMSRP', label:'Price ↑', reverse:false},
      {key: 'totalMSRP', label:'Price ↓', reverse:true},
      {key: 'year', label:'Year ↑', reverse:false},
      {key: 'year', label:'Year ↓', reverse:true},
      {key: 'make', label:'Make ↑', reverse:true},
      {key: 'make', label:'Make ↓', reverse:false},
      {key: 'model', label:'Model ↑', reverse:true},
      {key: 'model', label:'Model ↓', reverse:false},
      {key: 'color', label:'Color ↑', reverse:true},
      {key: 'color', label:'Color ↓', reverse:false}
    ];
    $scope.mobileSortKey = $scope.sortOptions[1];
    $scope.mobileSort = function (option) {
      $scope.sortKey = option.key;
      $scope.reverse = option.reverse;
    }
    $scope.filterCount = 0;



    $scope.initFilters = function () {
      return new Promise((resolve, reject) => {
        $scope.filtersLoading = true;
        apiFactory.vtInit(accountId, programId).then(function (response) {
          $scope.yearOptions = convertToOptions(response.data.years);
          $scope.emissionCodeOptions = convertToOptions(response.data.titleStates);

          $scope.filtersLoading = false;
          resolve();
        }, function errorCallback(response) {
          $scope.serverError = response.data.errors;
          $scope.filtersLoading = false;
          reject(response.data.errors);
        });
      });
    };

    $scope.mileageRanges = [
      { min: 10000, max: 9999999, label: 'More than 10,000 miles (vehicles over 10,000 miles are available for purchase only)', selected: false},
      { min: 7500, max: 10000, label: '7,500 to 10,000 miles', selected: false},
      { min: 5000, max: 7500, label: '5,000 to 7,500 miles', selected: false},
      { min: 1000, max: 5000, label: '1,000 to 5,000 miles', selected: false},
      { min: 0, max: 1000, label: 'Less than 1,000 miles', selected: false}
    ];
    $scope.msrpRanges = [
      { min: 85000, max: 9999999, label: '$85,000 and above', selected: false},
      { min: 70000, max: 85000, label: '$70,000 to $85,000', selected: false},
      { min: 55000, max: 70000, label: '$55,000 to $70,000 ', selected: false},
      { min: 0, max: 55000, label: '$55,000 and below ', selected: false},
    ];

    $scope.colors = [
      {label: 'Gray', selected: false},
      {label: 'Red', selected: false},
      {label: 'Blue', selected: false},
      {label: 'Green', selected: false},
      {label: 'Black', selected: false},
      {label: 'White', selected: false}
    ];

    $scope.filters = {
      make: undefined,
      year: undefined,
      model: undefined
    }
    $scope.models = {
      buick: [],
      chevrolet: [],
      gmc: [],
      cadillac: []
    }


    $scope.inRange = function (a, b) {
      if (b && b.length > 0) {
        for (var range of b) {
          if (a >= range.min && a <= range.max) {
            return true;
          }
        }
        return false;
      }
      return true;
    }

    $scope.filterYear = function () { //go thru loaded vehicles, get years, remove based on year
      if ($scope.filters.year) {
        $scope.loadedVehicles = $scope.loadedVehicles.filter(vehicle => vehicle.year == $scope.filters.year);
        $scope.filterCount++;
      };
    }

    $scope.filterMileage = function (){
      var filtered = 0;
      var ranges = [];
      $scope.mileageRanges.forEach(function(mileage) {
        if (mileage.selected){
          filtered++;
          ranges.push(mileage);
        };
      });
      if(filtered > 0) {
        //filter list based on ranges
        $scope.loadedVehicles = $scope.loadedVehicles.filter(vehicle => $scope.inRange(parseInt(vehicle.mileage,10), ranges));
        $scope.filterCount++;

      }
    }

    $scope.filterMSRP = function (){
      var filtered = 0;
      var ranges = [];

      $scope.msrpRanges.forEach(function(msrp) {
        if (msrp.selected){
          filtered++;
          ranges.push(msrp);
        };
      });
      if(filtered > 0) {
        //filter list based on ranges
        $scope.loadedVehicles = $scope.loadedVehicles.filter(vehicle => $scope.inRange(parseInt(vehicle.totalMSRP,10), ranges));
        $scope.filterCount++;
      }
    }

    $scope.hasColor = function (a,b) {
      if (b && b.length >0) {
        for (var color of b) {
          if (a.includes(color.label.toUpperCase())){
            return true;
          }
        }
        return false;
      }
      return true;
    }

    $scope.filterColors = function () {
      var filtered = 0;
      var paints = [];
      $scope.colors.forEach(function(color) {
        if (color.selected){
          filtered++;
          paints.push(color);
        };
      });
      if(filtered > 0) {
        $scope.loadedVehicles = $scope.loadedVehicles.filter(vehicle => $scope.hasColor(vehicle.color, paints));
        $scope.filterCount++;
      }
    }

    $scope.filterMake = function () {
      if ($scope.filters.make) {
        $scope.loadedVehicles = $scope.loadedVehicles.filter(vehicle => vehicle.make == $scope.filters.make.toUpperCase());
        $scope.filterCount++;
      }
    }
    $scope.filterModel = function () {
      if ($scope.filters.model) {
        $scope.loadedVehicles = $scope.loadedVehicles.filter(vehicle => vehicle.model == $scope.filters.model);
        $scope.filterCount++;
      }
    }

    $scope.processModel = function(make, model) {
      if (make == "BUICK"){
        if (!$scope.models.buick.includes(model)) {
          $scope.models.buick.push(model);
        }
      }
      if (make == "CADILLAC"){
        if (!$scope.models.cadillac.includes(model)) {
          $scope.models.cadillac.push(model);
        }
      }
      if (make == "CHEVROLET"){
        if (!$scope.models.chevrolet.includes(model)) {
          $scope.models.chevrolet.push(model);
        }
      }
      if (make == "GMC"){
        if (!$scope.models.gmc.includes(model)) {
          $scope.models.gmc.push(model);
        }
      }
    }

    $scope.updateModels = function() {
      var x = $scope.filters.make
      if (x) {
        if (x.toLowerCase() == 'buick') {
          $scope.availableModels = $scope.models.buick;
        }
        if (x.toLowerCase() == 'cadillac') {
          $scope.availableModels = $scope.models.cadillac;
        }
        if (x.toLowerCase() == 'chevrolet') {
          $scope.availableModels = $scope.models.chevrolet;
        }
        if (x.toLowerCase() == 'gmc') {
          $scope.availableModels = $scope.models.gmc;
        }
      }
      else {
        $scope.availableModels = [];
      }
    }

    $scope.updateFilters = function () {
      $scope.loadedVehicles = $scope.taggedVehicles;
      $scope.filterCount = 0;
      $scope.filterColors();
      $scope.filterMSRP();
      $scope.filterMileage();
      $scope.filterYear();
      $scope.filterMake();
      $scope.filterModel();
    }

    $scope.clearFilters = function () {
      $scope.mileageRanges = [
        { min: 10000, max: 9999999, label: 'More than 10,000 miles (vehicles over 10,000 miles are available for purchase only)', selected: false},
        { min: 7500, max: 10000, label: '7,500 to 10,000 miles', selected: false},
        { min: 5000, max: 7500, label: '5,000 to 7,500 miles', selected: false},
        { min: 1000, max: 5000, label: '1,000 to 5,000 miles', selected: false},
        { min: 0, max: 1000, label: 'Less than 1,000 miles', selected: false}
      ];
      $scope.msrpRanges = [
        { min: 85000, max: 9999999, label: '$85,000 and above', selected: false},
        { min: 70000, max: 85000, label: '$70,000 to $85,000', selected: false},
        { min: 55000, max: 70000, label: '$55,000 to $70,000 ', selected: false},
        { min: 0, max: 55000, label: '$55,000 and below ', selected: false},
      ];
      $scope.colors = [
        {label: 'Gray', selected: false},
        {label: 'Red', selected: false},
        {label: 'Blue', selected: false},
        {label: 'Green', selected: false},
        {label: 'Black', selected: false},
        {label: 'White', selected: false}
      ];
      $scope.filters = {
        make: undefined,
        year: undefined,
        model: undefined
      }
      $scope.availableModels = [];
      $scope.updateFilters();
    }

    $scope.availableYears = [];
    $scope.availableModels = [];

    $scope.submitTagSearch = function () {
      $scope.searchCriteria['category'] = '114677'; // EV Category
      const currentState = $scope.searchCriteria['emissionCode'].split('_')[1];
      const years = $scope.yearOptions.map(item => item.value);
      $scope.searchLoaded = false;

      let results = [];

      // I would have preferred to use Promise.all or even async/await, but alas we are working with obsolete runtimes
      function processYear(index) {
        if (index >= years.length) {
          $scope.taggedVehicles = results.flat();
          $scope.loadedVehicles = $scope.taggedVehicles;
          $scope.sortKey = 'mileage';
          $scope.sortData('mileage');
          $scope.searchLoaded = true;
          $scope.showResults = true;
          return;
        }

        $scope.searchCriteria['year'] = years[index];
        const queryString = VehicleDetailService.toURLQuery($scope.searchCriteria);
        apiFactory.vtSearch(accountId, programId, queryString).then(response => {
          let yearResults = [];
          response.data.vehicles.forEach(yearVehicle => {
            if (yearVehicle.locationState === currentState) {
                yearResults.push(yearVehicle);
                $scope.processModel(yearVehicle.make, yearVehicle.model);
                if (!$scope.availableYears.includes(yearVehicle.year)) {
                  $scope.availableYears.push(yearVehicle.year)
                }
            }
            $scope.availableModels.sort();
            $scope.availableYears.sort();
          });
          results.push(yearResults || []);
          processYear(index + 1);

        }).catch(error => {
          console.error('Error fetching data for year', years[index], error);
          results.push([]);
          processYear(index + 1);
        });
      }
      processYear(0);
    };

    $scope.getVehicleSummary = function(){
      var emissionCode = $scope.searchCriteria.emissionCode;
      $scope.searchLoaded = false;
      apiFactory.vtSummary(accountId, programId, emissionCode).then(function(response){
        $scope.taggedVehicles = response.data.vehicles || [];
        $scope.loadedVehicles = $scope.taggedVehicles.slice(0, 6);
        $scope.searchLoaded = true;
      }, function errorCallback(response){
        $scope.serverError = response.data.errors;
        $scope.searchLoaded = true;
      });
    };

    $scope.loadMoreTags = function(){
      var length = $scope.loadedVehicles.length;
      $scope.loadedVehicles = $scope.taggedVehicles.slice(0, length + 6);
    };

    $scope.showAllTags = function(){
      $scope.loadedVehicles = $scope.taggedVehicles;
    };

    $scope.clickedOnVehicle = function(criteria){
      $scope.saveCriteria = true;
      $scope.searchCriteria = criteria;
    };

  $scope.goToVehicleDetail = function (vin) {
      VehicleDetailService.destroyVehicleDetailVin();
      VehicleDetailService.setVehicleDetailVin(vin);
      VehicleDetailService.setSearchCriteria($scope.searchCriteria);
      $scope.customerPhone = CustomerService.getCustomerData().phone;
      $scope.searchLoaded = false;
      $scope.saveCriteria = true;
    };

    $scope.goOverview = function(){
      ProgramInfoService.addProgram(programPEP);
      $state.go('overview');
    };


    /**
     * Initialization code, execution basically starts here.
     * Needed to move $scope methods around so they would
     * be available when needed
    **/

    var accountId = AuthenticationService.getAuthenticatedID();
    var programId;
    var programPEP;
    $scope.searchLoaded = true;
    $scope.showResults = false;
    $scope.searchCriteria = {};
    $scope.taggedVehicles = [];
    $scope.loadedVehicles = [];
    $rootScope.hasPep = false;


    var onCustomerLoaded = function(customer) {
      if (customer) {
        accountId = AuthenticationService.getAuthenticatedID();
        var programIds = customer.programIDs;
        for(var i = 0; i < programIds.length; i++){
          if(programIds[i].code.toLowerCase() === 'vts'){
            programId = programIds[i].programID;
          }
          if (programIds[i].code.toLowerCase() === 'pep' || programIds[i].code.toLowerCase() === 'pepcont'){
            programPEP = programIds[i];
            $rootScope.hasPep = true;
          }

          if (programId && programPEP) {
            break;
          }
        }

        $scope.initFilters();

        // if coming from vin detail or state search
        if (['vehicle-tag-detail', 'available-vehicles'].indexOf($rootScope.fromState.name) >= 0) {
          $scope.searchCriteria = VehicleDetailService.getSearchCriteria();
          const prevEmissionCode = $scope.searchCriteria.emissionCode;
          if (Object.keys($scope.searchCriteria).length) {
            $scope.initFilters().then((resp) => {
              $scope.emissionCode = prevEmissionCode;
              $scope.submitTagSearch();
            });
          }
        }
      }
    };

    CustomerService.addObserver(onCustomerLoaded);

    $scope.$on("$destroy", function() {
      CustomerService.removeObserver(onCustomerLoaded);

      // Handles whether state should be saved between navigation
      if ($scope.saveCriteria) {
        VehicleDetailService.setSearchCriteria($scope.searchCriteria);
      } else {
        VehicleDetailService.setSearchCriteria({});
      }
    });
  }